import { Button, Card, Rows, Text } from "rothzerg-ui";

export function OnePassPromoCard() {
  return (
    <Card
      id="onepass-promo-card"
      variant="elevated"
      style={{
        background: "linear-gradient(135deg, #5b2d8e 0%, #7b3fb8 100%)",
        color: "#fff",
        padding: "1.5rem",
        minHeight: 280,
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
      }}
    >
      <Rows gap="sm">
        <Text variant="h4" style={{ color: "#fff", margin: 0 }}>
          OnePass
        </Text>
        <ul style={{ margin: 0, paddingLeft: "1.25rem", fontSize: "0.875rem" }}>
          <li>Free delivery on eligible items</li>
          <li>Click & Collect benefits</li>
          <li>Exclusive member offers</li>
        </ul>
      </Rows>
      <Button id="onepass-learn-more" variant="secondary" fullWidth>
        Learn more
      </Button>
    </Card>
  );
}
